export default {
  'npm_package_version': '1.0.0'
};



// WEBPACK FOOTER //
// d:/workspace/wynk_web_shoppings_3_prod/src/environments/.env.ts